'use client';

import { Children, type ReactNode, useEffect, useState } from 'react';
import { Carousel } from 'react-bootstrap';

type SocialImpactMobileCarouselProps = {
  children: ReactNode;
  carouselClassName: string;
  gridClassName: string;
};

export default function SocialImpactMobileCarousel({
  children,
  carouselClassName,
  gridClassName,
}: SocialImpactMobileCarouselProps) {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);
  const items = Children.toArray(children);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  if (isMobile === null) {
    return null;
  }

  if (isMobile) {
    return (
      <Carousel
        indicators={true}
        controls={false}
        interval={3000}
        slide={true}
        fade={false}
        pause="hover"
        className={carouselClassName}
      >
        {items.map((item, index) => (
          <Carousel.Item key={index}>{item}</Carousel.Item>
        ))}
      </Carousel>
    );
  }

  return <div className={gridClassName}>{items}</div>;
}
